import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import { AppButton } from '@/ui/buttons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--small-padding);
  align-self: center;
`;

const StyledIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  align-self: center;

  i {
    font-size: var(--body-font-size);
    color: var(--orange-main);
  }
`;

const StyledText = styled.div`
  color: var(--black-main);
  font-size: var(--xsmall-font-size);
  font-weight: 500;
  line-height: 150%;
  margin: 0;
`;

export const InlineBlockEmails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const handleEnableEmails = () => {
    currentAccount?.isSystem
      ? navigate(
          RedirectPaths[RedirectPathsEnum.ACCOUNTS_EMAILS_AND_DELIVERY](
            currentAccount?.id as string,
          ),
        )
      : navigate(
          RedirectPaths[RedirectPathsEnum.ACCOUNT_EMAILS_AND_DELIVERY](),
        );
  };

  return (
    <StyledContainer id="inline-block-emails">
      <StyledIcon>
        <i className="pi pi-info-circle" />
      </StyledIcon>
      <StyledText>
        {t('account.emails.inline.message')}{' '}
        <AppButton
          label={t('account.emails.inline.cta')}
          onClick={handleEnableEmails}
          severity="underline-always"
          size="xs"
          className="w-max"
        />
      </StyledText>
    </StyledContainer>
  );
};
